import { InjectionToken} from '@angular/core';

export interface PopoutData {
    title: string;
}

export const POPOUT_DATA = new InjectionToken<PopoutData>('POPOUT_DATA');
